import axios from "axios";
import { API_END_POINT } from "../../constants/api";

import { returnErrors, clearErrors } from "./errorAction";
export const PREVIEW_INVOICE = "PREVIEW_INVOICE";
export const ADD_INVOICE_SUCCESS = "ADD_INVOICE_SUCCESS";
export const EDIT_INVOCIE = "EDIT_INVOCIE";
export const EDIT_INVOICE_FAIL = "EDIT_INVOICE_FAIL";
export const EDIT_INVOICE_SUCCESS = "EDIT_INVOICE_SUCCESS";

export const DELETE_INVOCIE = "DELETE_INVOCIE";
export const DELETE_INVOICE_SUCCESS = "DELETE_INVOICE_SUCCESS";
export const DELETE_INVOICE_FAIL = "DELETE_INVOICE_FAIL";
export const ADD_INVOICE_FAIL = "ADD_INVOICE_FAIL";
export function generateInvoice(invoiceData) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const values = {
      ...invoiceData,
      invoice_date: invoiceData.invoice_date.format("YYYY-MM-DD"),
    };
    const body = JSON.stringify(values);
    axios
      .post(`${API_END_POINT}/api/Contract/Invoice`, body, config)
      .then((res) =>
        dispatch({
          type: PREVIEW_INVOICE,
          payload: res.data,
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "add invoice add Successfully",
            201,
            "ADD_INVOICE_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "ADD_INVOICE_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function editInvoice(updatedInvoice, id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const values = updatedInvoice.date
      ? {
          ...updatedInvoice,
          invoice_note: updatedInvoice.invoice_note.format("YYYY-MM-DD"),
        }
      : updatedInvoice;
    // const values = {
    //   ...invoiceData,
    //   invoice_date: invoiceData.invoice_date.format("YYYY-MM-DD"),
    // };
    const body = JSON.stringify(values);
    axios
      .put(`${API_END_POINT}/api/contract/invoice/update/${id}`, body, config)
      .then((res) =>
        dispatch({
          type: EDIT_INVOCIE,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors("Edit Invoice Successfully", 201, "EDIT_INVOICE_SUCCESS")
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "EDIT_INVOICE_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}

export function deleteInvoice(id, company_id) {
  return (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios
      .delete(
        `${API_END_POINT}/api/contract/invoice/delete/${id}/${company_id}`,

        config
      )
      .then((res) =>
        dispatch({
          type: DELETE_INVOCIE,
          payload: res.data[0],
        })
      )
      .then((data) =>
        dispatch(
          clearErrors(
            "Delete Invoice Successfully",
            201,
            "DELETE_INVOICE_SUCCESS"
          )
        )
      )
      .then(() => dispatch(clearErrors()))
      .catch((err) =>
        dispatch(
          returnErrors(
            err.response.data,
            err.response.status,
            "DELETE_INVOICE_FAIL"
          )
        )
      )
      .then(() => dispatch(clearErrors()));
  };
}
